const Reflux = require("reflux");
const DealLossReasonsActions = require("../actions/deal-loss-reasons-actions");

const DealLossReasonsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      lossReasons: []
    }
  },

  init: function() {
    this.listenTo(DealLossReasonsActions.fetchData, this.onFetchStarted);
    this.listenTo(DealLossReasonsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(DealLossReasonsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        lossReasons: data.loss_reasons
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = DealLossReasonsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/deal-loss-reasons-store.js